import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientSignatureType, FullClientInterface } from '../data';
import { TestProvider } from '../providers/test.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface SignTestUseCaseParams {
    client: FullClientInterface;
    signatureType: ClientSignatureType;
}

@Injectable()
export class SignTestUseCase implements UseCaseWithParam<SignTestUseCaseParams, Observable<Transaction<void>>> {
    constructor(private testProvider: TestProvider) {}

    bind(params: SignTestUseCaseParams): Observable<Transaction<void>> {
        return this.testProvider.sign(params.client.encryptedCode, params.signatureType);
    }
}
